<template>
    <div>
        <vue-good-wizard
                :steps="steps"
                class="mb-3"
                style="border-color: transparent;"
                :onNext="nextClicked"
                :onBack="backClicked">
            <div slot="page1">
                <!-- <p v-if="company.company[0] == null" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>-->
                <Form>
                    <b-row form>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgName">Company Name <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input v-model="model.orgName" type="text" name="orgName" id="orgName"
                                              placeholder="Company Name here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgIncNumber">Incorporation Number <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input v-model="model.orgIncNumber" type="text" name="orgIncNumber" id="orgIncNumber"
                                              placeholder="Incorporation Number here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgIncDate">Incorporation Date <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input v-model="model.orgIncDate" type="date" name="orgIncDate" id="orgIncDate"
                                              placeholder="Incorporation Date here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgType">Organisation Type <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <select v-model="model.orgType" class="form-control">
                                    <option value="" selected="selected">- Select -</option>
                                    <option value="Limited Liability">Limited Liability</option>
                                    <option value="Public Limited Company (PLC)">Public Limited Company (PLC)</option>
                                    <option value="Sole Proprietorship">Sole Proprietorship</option>
                                    <option value="Association">Association</option>
                                    <option  value="Non-profit Organisation">Non-profit Organisation</option>
                                    <option value="Partnership">Partnership</option>
                                    <option value="Enterprises/Business Names">Enterprises/Business Names</option>
                                </select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </Form>
            </div>
            <div slot="page2">
                <Form>
                    <b-row form>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgCountry">Country <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <country-select class="form-control" :countryName="true" :regionName="true" v-model="model.orgCountry" :country="model.orgCountry" topCountry="NG" />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgIncNumber">State <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <region-select class="form-control" :regionName="true" :countryName="true" v-model="model.orgState" :country="model.orgCountry" :region="model.orgState" />
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgCity">City <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input v-model="model.orgCity" type="text" name="orgCity" id="orgCity"
                                              placeholder="Company city here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgStreet">Street <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input v-model="model.orgStreet" type="text" name="orgStreet" id="orgStreet"
                                              placeholder="Company Street here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgPhone">Phone Number <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input v-model="model.orgPhone" type="text" name="phone" id="orgPhone"
                                              placeholder="Company Phone Number here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgEmail">Company Email <span style="color: red !important; display: inline; float: none;">*</span></Label>
                                <b-form-input v-model="model.orgEmail" type="email" name="email" id="orgEmail"
                                              placeholder="Company Emai here..."/>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group>
                                <Label for="orgWebsite">Website </Label>
                                <b-form-input v-model="model.orgWebsite" type="text" name="orgWebsite" id="orgWebsite"
                                              placeholder="Company Website here..."/>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </Form>
            </div>
            <div slot="page3">
                <strong>Please, confirm the information provided before submission.</strong>
                <br><br>
                <table class="table">
                    <tr>
                        <td style="font-size: 14px;">Company Name:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgName === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgName}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">Incorporation Number:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgIncNumber === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgIncNumber}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">Incorporation Date:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgIncDate === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{ model.orgIncDate }} </td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">Company Type:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgType === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgType}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">Country:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgCountry === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgCountry}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">State:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgState === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgState}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">City:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgCity === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgCity}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">Street:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgStreet === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgStreet}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">Phone Number:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgPhone === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgPhone}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">Email:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgEmail === ''" > This field is mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgEmail}}</td>
                    </tr>
                    <tr>
                        <td style="font-size: 14px;">Website:</td>
                        <td colspan="4" style="font-size: 14px;" v-if="model.orgWebsite === ''" > This field is not mandatory</td>
                        <td colspan="4" style="font-size: 14px;" v-else> {{model.orgWebsite}}</td>
                    </tr>
                </table>
            </div>
        </vue-good-wizard>
        <template>
            <loading :active.sync="company.createCompanyLoading"
                     :can-cancel="false"
                     color="#6d0606"
                     :is-full-page="fullPage"></loading>
        </template>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import Loading from 'vue-loading-overlay';
    //import Vue from "vue";
    export default {
        name: "ForgotForm",
        components:{Loading},
        data() {
            return {
                fullPage:true,
                companies:[],
                model: {
                    orgName: '',
                    orgIncNumber: '',
                    orgIncDate: '',
                    orgType:'',
                    orgCountry:'',
                    orgState:'',
                    orgCity:'',
                    orgStreet:'',
                    orgPhone:'',
                    orgEmail:'',
                    orgWebsite:'',
                    orgUserID:'',
                    requestType:'company',
                    subscribe: true
                },
                model1: {
                    username: '',
                    subscribe: true
                },
                steps: [
                    {
                        label: 'Details',
                        slot: 'page1',
                    },
                    {
                        label: 'Address',
                        slot: 'page2',
                    },
                    {
                        label: 'Confirm',
                        slot: 'page3',
                    }
                ],
            }
        },
        methods: {
            nextClicked(currentPage) {
                console.log('next clicked', currentPage)
                if (currentPage >= this.steps.length-1)
                    this.createCompany()
                return true; //return false if you want to prevent moving to next page
            },
            backClicked(currentPage) {
                console.log('back clicked', currentPage);
                return true; //return false if you want to prevent moving to previous page
            },
            async createCompany(){
                this.model.dialogs = this.$dialogs
                this.model.orgIncDate = this.$moment(this.model.orgIncDate).format('YYYY-MM-DD')
                console.log(this.model.orgIncDate)
                if (this.model.orgName !== ''
                    && this.model.orgIncNumber !== ''
                    && this.model.orgIncDate !== ''
                    && this.model.orgType !== ''
                    && this.model.orgCountry !== ''
                    && this.model.orgState !== ''
                    && this.model.orgCity !== ''
                    && this.model.orgStreet !== ''
                    && this.model.orgPhone !== ''
                    && this.model.orgEmail !== ''
                ) {
                    this.model.orgUserID = this.system.userInfo.id;
                    this.model.firstName = this.system.userInfo.firstName;
                    this.model.lastName = this.system.userInfo.lastName;
                    await this.$store.dispatch('company/createCompany', this.model, {root: true})

                }else{
                    const options = {title: 'Error!', size: 'sm'}
                    this.$dialogs.alert('Empty field detected. Please fill fields with the (*)', options)
                        .then(res => {
                            console.log(res) // {ok: true|false|undefined}
                            //this.$router.go(-1)
                        })
                }
            },
        },
        computed:{
            ...mapState([
                'company',
                'document',
                'system',
                'officer',
            ]),
        }
    }
</script>

<style scoped>

</style>